import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { CircleState, Circle } from './types';

const initialState: CircleState = {
  circles: [],
  currentCircle: null,
  isLoading: false,
  hasLoaded: false,
  error: null
};

export const slice = createSlice({
  name: 'circle',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action: PayloadAction<unknown>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getCirclesSuccess(state, action: PayloadAction<Circle[]>) {
      state.isLoading = false;
      state.hasLoaded = true;
      state.circles = action.payload;
    },
    createCircleSuccess(state, action: PayloadAction<Circle>) {
      state.isLoading = false;
      state.circles.push(action.payload);
    },
    updateCircleSuccess(state, action: PayloadAction<{ guid: string; circle: Partial<Circle> }>) {
      state.isLoading = false;
      const index = state.circles.findIndex((circle) => circle.guid === action.payload.guid);
      if (index !== -1) {
        state.circles[index] = { ...state.circles[index], ...action.payload.circle };
      }
      if (state.currentCircle?.guid === action.payload.guid) {
        state.currentCircle = { ...state.currentCircle, ...action.payload.circle };
      }
    },
    deleteCircleSuccess(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.circles = state.circles.filter((circle) => circle.guid !== action.payload);
      if (state.currentCircle?.guid === action.payload) {
        state.currentCircle = null;
      }
    }
  }
});

export default slice.reducer;
